import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult, InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";
import { Provider } from 'react-redux';
import { HashRouter} from 'react-router-dom';
import {store} from  './app/store';
import {
  persistStore,
} from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'


// import your fontawesome library
import './fontawesome';

// MSAL imports

export const msalInstance = new PublicClientApplication(msalConfig);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult;
        const account = payload.account;
        ;
        msalInstance.setActiveAccount(account);
        ;
    }
    
});



const container = document.getElementById('root')||document.createElement('div');
const root = ReactDOM.createRoot(container);

let persistor = persistStore(store);
root.render(
    
    <HashRouter >
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <App pca={msalInstance} />
    </PersistGate>
    </Provider>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
